import React, { useState } from 'react';
import { artworks, categories } from '../data/mock';

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredArtworks = activeCategory === 'All' 
    ? artworks 
    : artworks.filter(art => art.category === activeCategory);

  return (
    <section id="gallery" className="section-padding bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="section-heading-custom mb-4">Art Gallery</h2>
          <p className="body-large-custom max-w-2xl mx-auto opacity-60">
            Explore a collection of unique artworks, each piece crafted with passion and creativity
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => setActiveCategory(category.name)}
              className={`service-button ${
                activeCategory === category.name ? 'active' : ''
              }`}
              style={{
                background: activeCategory === category.name ? category.color : 'white',
                borderColor: category.color,
                color: activeCategory === category.name ? '#151515' : '#717171'
              }}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {filteredArtworks.map((artwork) => (
            <div
              key={artwork.id}
              className="artwork-card group"
            >
              <div className="artwork-image-container">
                <img
                  src={artwork.image}
                  alt={artwork.title}
                  className="artwork-image"
                />
                <div className="artwork-overlay">
                  <div className="p-6 space-y-3">
                    <h3 className="text-white text-2xl font-bold">{artwork.title}</h3>
                    <p className="text-white text-base opacity-95">
                      {artwork.description}
                    </p>
                    <div className="flex items-center justify-between pt-2">
                      <span className="service-button" style={{ background: '#ffe03d', color: '#151515' }}>
                        {artwork.category}
                      </span>
                      <span className="text-white font-mono text-2xl font-bold">
                        {artwork.price}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredArtworks.length === 0 && (
          <div className="text-center py-16">
            <p className="body-large-custom opacity-60">
              No artworks found in this category
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
